import React, { ReactElement } from 'react'
import { useNavigate } from 'react-router'
import { Add } from '@mui/icons-material'
import { useAppId } from 'src/app/AppProvider'
import { useTranslate } from 'src/i18n/useMessageSource'
import { NavigateState } from 'src/routing/Routing'
import { Permission } from 'src/service/backend/api'
import { ListingButton } from 'src/ui-shared/base/button/ListingButton'
import { ScreenLayout } from 'src/ui/layout/main-layout/ScreenLayout'
import { OrganizationTable } from 'src/ui/page/common/organization/list/OrganizationTable'
import { hasPermission } from 'src/user/RoleCheck'
import { useUser } from 'src/user/UserContext'

export const ServicePartnerListPage = (): ReactElement => {
  const translate = useTranslate()

  const navigate = useNavigate()
  const appId = useAppId()
  const user = useUser()

  const handleRowClick = (servicePartnerId?: string) => {
    navigate(`/${appId}/service-partners/${servicePartnerId}/view`, {
      state: { browserHistoryBack: true } as NavigateState,
    })
  }

  const handleCreateButtonClick = () => {
    navigate(`/${appId}/service-partners/create`)
  }

  const createNewAction = (
    <ListingButton onClick={handleCreateButtonClick} variant="outlined" color="primary" startIcon={<Add />}>
      {translate('createNew')}
    </ListingButton>
  )

  const actions = hasPermission(user, Permission.ORGANIZATION_WRITE) ? createNewAction : <></>

  return (
    <ScreenLayout title={translate('servicePartners')} actions={actions}>
      <OrganizationTable navigateToItem={handleRowClick} isServicePartner></OrganizationTable>
    </ScreenLayout>
  )
}
